import { apiSlice } from '../api/apiSlice';
import {
  GetPackagesParams,
  Package,
  PackagesResponse,
} from './packageApiSliceTypes';

const packageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPackages: builder.query<PackagesResponse, GetPackagesParams>({
      query: (params) => {
        const { page = 1, limit = 10, ...queryParams } = params ?? {};

        return {
          url: '/packages',
          method: 'GET',
          headers: {
            'Accept-Language': 'en',
          },
          params: {
            page,
            limit,
            ...queryParams,
          },
        };
      },
    }),

    getPackage: builder.query<Package, { id: string; acceptLanguage?: string }>(
      {
        query: ({ id, acceptLanguage = 'en' }) => ({
          url: `/packages/${id}`,
          method: 'GET',
          headers: {
            'Accept-Language': acceptLanguage,
          },
        }),
      }
    ),

    getSimilarPackages: builder.query<
      Package[],
      { id: string; acceptLanguage?: string }
    >({
      query: ({ id, acceptLanguage = 'en' }) => ({
        url: `/packages/${id}/similar`,
        method: 'GET',
        headers: {
          'Accept-Language': acceptLanguage,
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
  useGetPackageQuery,
  useLazyGetPackageQuery,
  useGetSimilarPackagesQuery,
  useLazyGetSimilarPackagesQuery,
} = packageApiSlice;
